import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const kitchenTopPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,

  COMMONS_APPBAR_BG: 'bg-[#52A1A8]',
  COMMONS_APPBAR_TEXT: 'text-white',

  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',

  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',

  COMMONS_FOOTER_BG: 'bg-[#52A1A8]',
  COMMONS_FOOTER_TEXT: 'text-white',

  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#FBA74B] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',

  HOMEPAGE_HEADER_BG: 'bg-[#E9F8D8]',
  HOMEPAGE_HEADER_TEXT: 'text-black',

  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#52A1A8]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#FBA74B]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#FBA74B] hover:border-[#FBA74B] hover:bg-[#FBA74B] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#52A1A8]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#52A1A8]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#52A1A8]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#FBA74B]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#345074] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#52A1A8] text-[#52A1A8] [&>svg>path]:stroke-[#52A1A8] [&>svg>g>path]:stroke-[#52A1A8] [&>svg>path]:fill-[#52A1A8] [&>svg>g>path]:fill-[#52A1A8]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#345074]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#52A1A8]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#E9F8D8]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#FBA74B]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#E9F8D8]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#52A1A8] [&>.explore-icon-fill]:!fill-[#E9F8D8] [&>g>.explore-icon-fill]:!fill-[#E9F8D8]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#E9F8D8] [&>.vector-top>path]:fill-[#52A1A8] [&>.vector-bottom>path]:fill-[#52A1A8]',

  LISTPAGE_USER_VALUE_BADGE: 'text-[#52A1A8] [&>div>svg>path]:fill-[#52A1A8] bg-[#E9F8D8]',

  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#E9F8D8]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#52A1A8]',

  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#FBA74B]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-white',

  LISTPAGE_BADGE_WINNER_BG: 'bg-[#E9F8D8]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#52A1A8]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#52A1A8]',

  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#E9F8D8]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#52A1A8]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#52A1A8]',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#FBA74B]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#E9F8D8]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#52A1A8]',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#E9F8D8]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',

  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#52A1A8]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#52A1A8]',

  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#E9F8D8]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#030303]',

  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#345074] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#52A1A8] text-[#52A1A8] [&>svg>path]:stroke-[#52A1A8] [&>svg>g>path]:stroke-[#52A1A8] [&>svg>path]:fill-[#52A1A8] [&>svg>g>path]:fill-[#52A1A8]',
  LISTPAGE_BUTTON_LINK: 'text-[#345074]',
  LISTPAGE_ANCHOR_LINK: 'text-[#345074]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#345074]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#345074]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#345074]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#345074] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#345074] text-[#345074]  [&>svg>path]:stroke-[#345074] [&>svg>g>path]:stroke-[#345074] [&>svg>path]:fill-[#345074] [&>svg>g>path]:fill-[#345074]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#345074]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#345074]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#345074]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#345074]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#345074]',

  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#E9F8D8] [&>.vector-top>path]:fill-[#52A1A8] [&>.vector-bottom>path]:fill-[#52A1A8]',

  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#E9F8D8] [&>circle]:stroke-[#E9F8D8] [&>path]:fill-[#52A1A8]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#E9F8D8]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#52A1A8]',

  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-[#345074] bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#345074]',
}
